import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { MapPin, User, ArrowRight, Tag, Star } from "lucide-react";
import { TIPO_META, ROL_META, haceCuanto, formatearPrecio } from "../../lib/conexion";
import { PlanBadge } from "../../components/PlanBadge";

export default function PublicacionCard({ pub, onClick }) {
  const meta = TIPO_META[pub.tipo] || TIPO_META.solicitud;
  const rolMeta = ROL_META[pub.usuario_rol] || {};
  const navigate = useNavigate();

  const irAlPerfil = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (pub.usuario_id) navigate(`/conexion/perfil/${pub.usuario_id}`);
  };

  return (
    <Link
      to={`/conexion/publicaciones/${pub.id}`}
      onClick={onClick}
      data-testid={`publicacion-card-${pub.id}`}
      className={`group bg-white rounded-2xl border shadow-soft hover:shadow-lifted hover:-translate-y-0.5 transition-all overflow-hidden flex flex-col ${pub.destacado ? "border-brand-red/40 ring-1 ring-brand-red/20" : "border-slate-100"}`}
    >
      <div className="p-5 flex flex-col h-full">
        <div className="flex items-center justify-between gap-2 mb-3">
          <div className="flex items-center gap-1.5">
            <span
              className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full"
              style={{ color: meta.color, backgroundColor: meta.tint }}
            >
              {meta.label}
            </span>
            {pub.destacado && (
              <span
                className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-brand-red text-white"
                data-testid={`publicacion-destacado-${pub.id}`}
              >
                <Star size={11} /> Destacado
              </span>
            )}
          </div>
          <span className="text-[11px] text-slate-400 font-medium">{haceCuanto(pub.fecha)}</span>
        </div>

        <h3 className="text-base font-bold text-slate-900 leading-snug line-clamp-2 group-hover:text-brand-blue transition-colors">
          {pub.titulo}
        </h3>
        <p className="mt-1.5 text-sm text-slate-600 leading-relaxed line-clamp-2">{pub.descripcion}</p>

        <div className="mt-4 grid grid-cols-1 gap-1.5 text-xs text-slate-500">
          <div className="flex items-center gap-1.5">
            <Tag size={12} className="text-slate-400" />
            <span className="font-medium">{pub.categoria}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <MapPin size={12} className="text-slate-400" />
            <span>
              {pub.ubicacion?.distrito}, {pub.ubicacion?.provincia}, {pub.ubicacion?.region}
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <User size={12} className="text-slate-400" />
            <span
              onClick={irAlPerfil}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter") irAlPerfil(e); }}
              data-testid={`publicacion-autor-${pub.id}`}
              className="truncate font-semibold text-brand-blue hover:text-brand-red hover:underline cursor-pointer"
            >
              {pub.usuario_nombre}
            </span>
            <PlanBadge plan={pub.usuario_plan} />
            {rolMeta.label && (
              <span className="ml-1 text-[10px] font-bold uppercase tracking-wide" style={{ color: rolMeta.color }}>
                · {rolMeta.label}
              </span>
            )}
          </div>
        </div>

        <div className="mt-auto pt-4 flex items-center justify-between">
          {pub.precio != null ? (
            <p className="text-lg font-extrabold" style={{ color: meta.color }}>
              {formatearPrecio(pub.precio)}
            </p>
          ) : (
            <span className="text-xs text-slate-400 font-medium">Precio a convenir</span>
          )}
          <span className="inline-flex items-center gap-1 text-xs font-bold text-brand-blue group-hover:text-brand-red transition-colors">
            Ver detalle <ArrowRight size={12} />
          </span>
        </div>
      </div>
    </Link>
  );
}
